export default __webpack_public_path__ + "static/media/Bhandarkarlogo.4f7d4694.png";